import Vue from 'vue'
import Router from 'vue-router'
import SearchPage from './../pages/SearchPage.vue'
import RecordDetailsPage from './../pages/RecordDetailsPage.vue'
import Results from '../components/layout-components/Results.vue'
import ChallengeMode from '@/components/challenge-components/ChallengeMode'
import store from '@/store/index'

Vue.use(Router)

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: {
          x: 0,
          y: window.innerWidth > 1024 ? 50 : 0,
        },
      }
    } else if (
      savedPosition ||
      (to.name === 'Search' && from.name === 'Search')
    ) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0,
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'SearchPage',
      component: SearchPage,
      redirect: '/search/',
      children: [
        {
          path: 'search/:search?',
          name: 'Search',
          component: Results,
        },
      ],
    },
    {
      path: '/record/:id/:currentTab?',
      name: 'RecordDetailsPage',
      component: RecordDetailsPage,
      meta: { checkLogin: true, },
      children: [
        {
          path: 'challenge/:tab?',
          name: 'Challenge',
          components: {
            challengePage: ChallengeMode,
          },
        },
      ],
    },
    {
      path: '*',
      redirect: '/search/',
      meta: { checkLogin: true, },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const requiresLogin = to.meta.checkLogin

  if (!requiresLogin) {
    return next()
  }

  if (!store.getters['auth/authUser']) {
    store.dispatch('auth/getAuthUser')
      .catch((error) => {
        // no op
        // Note: Don't change if you don't know what you are doing
        // @see https://gitlab.gleif.org/gleif/external/code-and-care/lei-search-2.0/-/issues/127/
      })
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js